import React, { useEffect, useState } from 'react';
import { TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { useSiteDialogComponents } from '../../hooks/site-dialog/useSiteDialogComponents';
const SiteDialogPicker = props => {
    const { value, variant, onChange } = props;
    const dialogs = useSiteDialogComponents();
    const [selected, setSelected] = useState(() => {
        return value ? dialogs.find(dialog => dialog.id === value) : undefined;
    });
    useEffect(() => {
        setSelected(dialogs.find(dialog => dialog.id === value));
    }, [value, dialogs]);
    const additionalInputProps = {};
    if (!variant)
        additionalInputProps.disableUnderline = true;
    return (React.createElement(Autocomplete, { fullWidth: true, options: dialogs, value: selected || null, getOptionLabel: option => {
            var _a;
            const { name } = option;
            const title = (_a = option.props) === null || _a === void 0 ? void 0 : _a.title;
            return title ? `${title} (${name})` : name;
        }, onChange: (_, newValue) => {
            const value = newValue || undefined;
            onChange === null || onChange === void 0 ? void 0 : onChange(value);
            setSelected(value && dialogs.find(dialog => dialog.id === value.id));
        }, renderInput: params => (React.createElement(TextField, Object.assign({ variant: variant }, params, { fullWidth: true, size: 'small', placeholder: 'Select Dialog', InputProps: Object.assign(Object.assign({}, params.InputProps), additionalInputProps) }))) }));
};
export default SiteDialogPicker;
//# sourceMappingURL=SiteDialogPicker.js.map